export default function billingAccountFactory() {
  const BSCS = window.adacado.bscs
  const myToken = BSCS.getToken()

  return {
    getBillingAccountV2(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/billingaccount/v2/retrieve',
        requestParameters: [],
        callback: (billingaccount,token,annotation) => {
          if (billingaccount && billingaccount.Properties && typeof billingaccount.Properties == 'string') {
            billingaccount.Properties = JSON.parse(billingaccount.Properties)
          }
          callback(billingaccount,token==myToken,annotation)
        }
      })
    },
    updateBillingAddressAndName(billingAccountAddressAndName) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'PUT',
        requestPath: '/billingaccount/v1/update/addressandname',
        payload: billingAccountAddressAndName
      })
    },
    setShopifyUserV2() {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'PUT',
        requestPath: '/billingaccount/v1/setshopifyuser',
        payload: ''
      })
    },
    getIsShopifyUser(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/billingaccount/v1/isshopifyuser',
        requestParameters: [],
        callback: (isShopifyUser, token, annotation) => {
          callback(isShopifyUser, token===myToken, annotation)
        }
      })
    },
    getIsDisabled(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/billingaccount/v2/isdisabled',
        requestParameters: [],
        callback: (isDisabled, token, annotation) => {
          callback(isDisabled, token===myToken, annotation)
        }
      })
    },
    getHasValidPaymentInfo(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/billingaccount/v2/hasvalidpaymentinfo',
        requestParameters: [],
        callback: (hasValidPaymentInfo, token, annotation) => {
          callback(hasValidPaymentInfo, token===myToken, annotation)
        }
      })
    },
    validateAndRedeemPromoCode(payload) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'POST',
        requestPath: '/billingaccount/v2/validateandredeempromocode',
        payload
      })
    },
    updateFreemiumAdvertiserId(payload) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'POST',
        requestPath: '/billingaccount/v2/updatefreemiumadvertiserid',
        payload
      })
    },
    getFreemiumIsActive(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/billingaccount/v2/freemiumisactive',
        requestParameters: [],
        callback: (isActive, token, annotation) => {
          callback(isActive, token===myToken, annotation)
        }
      })
    },
    updateFreemiumIsActive(payload) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'POST',
        requestPath: '/billingaccount/v2/updatefreemiumisactive',
        payload
      })
    },
  }
}
